
const digest = 'c6fe4d62097a8b034e2478203d0145c6d92584d7a659cb64b83bf576728c02fe';
const classes = {"wrapper":"_wrapper_ovmbe_1","title":"_title_ovmbe_8","alignTitle":"_alignTitle_ovmbe_12","value":"_value_ovmbe_15","hideNoise":"_hideNoise_ovmbe_86","extra":"_extra_ovmbe_146","iconWrapper":"_iconWrapper_ovmbe_151","noiseButton":"_noiseButton_ovmbe_158"};
const css = `._wrapper_ovmbe_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 15px;
}
._wrapper_ovmbe_1 ._title_ovmbe_8 {
  font-size: 14px;
  color: #9ea0a5;
}
._wrapper_ovmbe_1 ._alignTitle_ovmbe_12 {
  min-width: 260px;
}
._wrapper_ovmbe_1 ._value_ovmbe_15 {
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_ovmbe_1 ._value_ovmbe_15 article[data-type=COMPOSITION]::before {
  font-weight: Bold;
  color: #253463;
  content: "" attr(data-name) "";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=CLUSTER]::before {
  font-weight: Bold;
  color: #253463;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=CONTENT]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=ENTRY]::before {
  font-weight: Bold;
  color: #253463;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=ELEMENT]::before {
  font-weight: Bold;
  color: #253463;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=ITEM]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=CODED_VALUE]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=BOOLEAN]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=CODED_SIMPLE]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=SIMPLE_TEXT]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=DATE_TIME]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section[data-type=AUDIT_INFO]::before {
  font-weight: Bold;
  color: #6da325;
  content: "" attr(data-name) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section::before {
  font-weight: Bold;
  content: "" attr(data-type) ": ";
}
._wrapper_ovmbe_1 ._value_ovmbe_15 section {
  margin-left: 20px;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=value]::before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=value] {
  margin-left: 0;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=value]::before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=items] {
  margin-left: 0;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=items]::before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=parts] {
  margin-left: 0;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=parts]::before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=audits] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=version_status] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=content] {
  margin-left: 0;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-name=content]:before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code_system] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code_schema_version] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=display_name]:before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code_system] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code_schema_version] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=code] {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=display_name]:before {
  display: none;
}
._wrapper_ovmbe_1 ._value_ovmbe_15._hideNoise_ovmbe_86 section[data-type=INSTANCE_IDENTIFIER] {
  display: none;
}
._wrapper_ovmbe_1 ._extra_ovmbe_146 {
  font-size: 12px;
  color: #ccc;
  font-weight: 500;
}
._wrapper_ovmbe_1 ._iconWrapper_ovmbe_151 {
  display: flex;
}
._wrapper_ovmbe_1 ._iconWrapper_ovmbe_151 img {
  width: 18px;
  height: 18px;
}
._wrapper_ovmbe_1 ._noiseButton_ovmbe_158 {
  color: #0a53be;
  cursor: pointer;
  display: block;
  margin-bottom: 10px;
  text-decoration: underline;
  font-weight: bold;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  